var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditTemplate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.883,
    height: 20.883,
    viewBox: "0 0 20.883 20.883",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit",
    transform: "translate(-3.1 -3.511)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.794,8.8,4,18.6v4.9H8.9L18.69,13.7m-4.9-4.9,3.512-3.512,0,0a3.034,3.034,0,0,1,1-.816,1.224,1.224,0,0,1,.757,0,3.031,3.031,0,0,1,1,.815l2.13,2.13a3.043,3.043,0,0,1,.818,1.007,1.224,1.224,0,0,1,0,.757,3.036,3.036,0,0,1-.817,1.006h0L18.69,13.7m-4.9-4.9,4.9,4.9",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#777",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditTemplate);
export default __webpack_public_path__ + "static/media/editTemplate.520fb3f71ddd0e65e438fc44c871cfa5.svg";
export { ForwardRef as ReactComponent };